import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BeanStatusMonitory } from 'src/bean/BeanStatusMonitory';
import { environment } from 'src/environments/environment';

@Injectable()
export class StatusMonitoryService {

  constructor(
    private http: HttpClient
  ) { }

  public getHeaders(){

    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization' : 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return headers;
  }

  public listarStatusMonitory(idMonitory:string):Observable<any> {

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.getAllStatusMonitoryByIdMonitory}${idMonitory}`, {headers});
  }

  addStatusMonitory(statusMonitory: BeanStatusMonitory, qtdApontamentoGrave: Number):Promise<any>{
    return this.gravarStatusMonitory(statusMonitory, qtdApontamentoGrave).toPromise().then((resposta:any) => resposta);
  }

  public gravarStatusMonitory(statusMonitory: BeanStatusMonitory, qtdApontamentoGrave: Number):Observable<any>{

    const headers = this.getHeaders();

    let json = JSON.stringify(statusMonitory);

    return this.http.post(`${environment.urlBackend}${environment.criarStatusMonitory}`+qtdApontamentoGrave,json, {headers});
  }

  deleteStatusMonitory(stmaIdCdStatusMonitoria: string):Promise<any>{
    return this.excluirStatusMonitory(stmaIdCdStatusMonitoria).toPromise();
  }

public excluirStatusMonitory(stmaIdCdStatusMonitoria: string):Observable<any> {

  const headers = this.getHeaders();


  return this.http.delete(`${environment.urlBackend}${environment.deleteStatusMonitoryById}${stmaIdCdStatusMonitoria}`, {headers});
}
}
